import { render, staticRenderFns } from "./ConfirmSubmitDialog.vue?vue&type=template&id=3615bb32&scoped=true"
import script from "./ConfirmSubmitDialog.vue?vue&type=script&lang=js"
export * from "./ConfirmSubmitDialog.vue?vue&type=script&lang=js"
import style0 from "./ConfirmSubmitDialog.vue?vue&type=style&index=0&id=3615bb32&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3615bb32",
  null
  
)

export default component.exports